<script setup>
import { defineProps, defineEmits } from 'vue';

const props =defineProps({
    molecule: {
        type: Object,
        required: true
    },
    isActive: {
        type: Boolean,
        required: false,
        default: false
    }
});

const emit = defineEmits(['select']);

const openModal = () => {
    emit('select', props.molecule);
};
</script>

<template>

    <div class="Molecule" @click="openModal" :data-active="isActive">
        <img :src="'molecules/' + molecule.image_base + '.png'" :alt="molecule.label" class="Molecule__image-main" />
        <img :src="'molecules/' + molecule.image_base + '-high.png'" :alt="molecule.label" class="Molecule__image-hover" />
    </div>
</template>


<style lang="scss" scoped>
.Molecule {
    cursor: pointer;
    width: 118px;
    height: 90px;

    &__image {

        &-main {
            //
        }

        &-hover {
            display: none
        }


    }

    &:hover, &[data-active="true"] {
        .Molecule__image-hover {
            display: block;
        }
        .Molecule__image-main {
            display: none;
        }
    }

}
</style>
